/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Spaces_Create_Dataset_DescInputs */



/**
* | output |
* | --- |
* | "Allows creating structured dataset spaces (oneData)." |
*
* @param {Rights_Cap_Spaces_Create_Dataset_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_spaces_create_dataset_desc = /** @type {((inputs?: Rights_Cap_Spaces_Create_Dataset_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Spaces_Create_Dataset_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erlaubt das Erstellen strukturierter Datensatz-Spaces (oneData).")
	return /** @type {LocalizedString} */ ("Allows creating structured dataset spaces (oneData).")
});